var FiltersMixin = {
  methods: {
    resetFilters(filtersApplied, fieldsToExcludeFromFilters) {
      // Los filtros fijos no se pueden resetear
      for (let [key] of Object.entries(filtersApplied)) {
        var resetFilter = !(fieldsToExcludeFromFilters.length > 0 && fieldsToExcludeFromFilters.includes(key));
        if (resetFilter) {
          this.$set(filtersApplied, key, null);
        }
      }
    }
  }

};
export default FiltersMixin;